import { useDispatch, useSelector } from 'react-redux'

import {
    toggleCompareProduct
} from '../compare/compare-actions';

/**
 * @typedef {Object} CompareFunctions
 * @property {function(): promise} toggleCompareProduct - Toggles product for compare
 * @property {function(): Boolean} isSelected - Checks even given product SKU is being compared
 */

/**
 * Returns redux connected compare functions and state
 * @name useProductCompare
 * @returns {CompareFunctions}
 */
export default function useProductCompare() {
    const dispatch = useDispatch();
    const compareProducts = useSelector(state => state.compare.products);

    return {
        toggleCompareProduct: (product, isV2) => dispatch(toggleCompareProduct(product, isV2)),
        isSelected: sku => (compareProducts || []).filter(p => p.sku === sku).length > 0
    };
}